import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { BottomNav } from './components/BottomNav';
import { HomePage } from './pages/HomePage';
import { VideoDetailPage } from './pages/VideoDetailPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { CreatorStudioPage } from './pages/CreatorStudioPage';
import { AdminPage } from './pages/AdminPage';
import { ProfilePage } from './pages/ProfilePage';
import { ForYouPage } from './pages/ForYouPage';
import { AdhesionPage } from './pages/AdhesionPage';
import { FavorisPage } from './pages/FavorisPage';
import { ReferralPage } from './pages/ReferralPage';
import { BecomeCreatorPage } from './pages/BecomeCreatorPage';
import { MyProfilePage } from './pages/MyProfilePage';
import { SettingsPage } from './pages/SettingsPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { AdminCreatorRequestsPage } from './pages/AdminCreatorRequestsPage';
import { PersonProfilePage } from './pages/PersonProfilePage';
import { SitemapPage } from './pages/SitemapPage';
import { Footer } from './components/Footer';
// Admin pages
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { AdminVideosPage } from './pages/AdminVideosPage';
import { AdminCreatorsPage } from './pages/AdminCreatorsPage';
import { AdminPayoutsPage } from './pages/AdminPayoutsPage';
import { AdminPromoPage } from './pages/AdminPromoPage';
import { AdminBroadcastPage } from './pages/AdminBroadcastPage';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { AdminLogsPage } from './pages/AdminLogsPage';
import { AdminAnalyticsPage } from './pages/AdminAnalyticsPage';
import './App.css';

export default function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <div className="App pb-20">
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/video/:videoId" element={<VideoDetailPage />} />
              <Route path="/person/:personId" element={<PersonProfilePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/become-creator" element={<BecomeCreatorPage />} />
              <Route path="/creator/studio" element={<CreatorStudioPage />} />
              {/* Admin — ancienne page conservée pour compatibilité */}
              <Route path="/admin/old" element={<AdminPage />} />
              <Route path="/admin/creator-requests" element={<AdminCreatorRequestsPage />} />
              {/* Admin — nouveau système */}
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/videos" element={<AdminVideosPage />} />
              <Route path="/admin/creators" element={<AdminCreatorsPage />} />
              <Route path="/admin/payouts" element={<AdminPayoutsPage />} />
              <Route path="/admin/promo" element={<AdminPromoPage />} />
              <Route path="/admin/broadcast" element={<AdminBroadcastPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/admin/logs" element={<AdminLogsPage />} />
              <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
              {/* User pages */}
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/my-profile" element={<MyProfilePage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/pour-vous" element={<ForYouPage />} />
              <Route path="/adhesion" element={<AdhesionPage />} />
              <Route path="/favoris" element={<FavorisPage />} />
              <Route path="/referral" element={<ReferralPage />} />
              <Route path="/sitemap" element={<SitemapPage />} />
            </Routes>
            <Footer />
            <BottomNav />
            <Toaster
              position="top-right"
              toastOptions={{
                className: 'bg-card border-border text-foreground',
              }}
            />
          </div>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

